module.exports = __webpack_public_path__ + "static/media/rscreen.21de3476.png";